import React, { useEffect, useState } from "react";
import "../../../assets/scss/components/track-overlay.scss";
import Select from "react-select";
import { getPricingTier } from "../../../actions/user";
import { useSelector } from "react-redux";
import { ReleaseState } from "@type/models/store";

type OptionType = {
  value: string;
  label: string;
};

interface FormData {
  price?: OptionType;
}

interface PriceProps {
  handleSubmission: (field: string, data: FormData) => void;
  callFunction: boolean;
  localStorageCleared: boolean;
  clearForm: boolean;
}

let initialFormData: FormData = {
  price: undefined,
};

const loadFormDataFromLocalStorage = () => {
  const savedData = localStorage.getItem("releasePrice");
  return savedData ? JSON.parse(savedData) : initialFormData;
};

const Price: React.FC<PriceProps> = ({
  handleSubmission,
  callFunction,
  localStorageCleared,
  clearForm,
}) => {
  const [formData, setFormData] = useState<FormData>(initialFormData);
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [priceTierList, setPriceTierList] = useState<any[]>([]);
  const { price } = useSelector(
    (state: ReleaseState) => state.releaseInfo.releaseInfo
  );

  const handleSubmit = () => {
    const validationErrors: Record<string, string> = {};

    if (!formData.price) {
      validationErrors.price = "Price cannot be empty.";
    }

    saveFormDataToLocalStorage();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    } else {
      if (handleSubmission) {
        handleSubmission("price", formData);
      }
    }
  };

  const handleInputChange = (selectedOption: any) => {
    setFormData({
      ...formData,
      price: selectedOption,
    });
  };

  const saveFormDataToLocalStorage = () => {
    localStorage.setItem("releasePrice", JSON.stringify(formData));
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        let priceTierRes = await getPricingTier();
        priceTierRes = priceTierRes.map((price) => ({
          ...price,
          label: price.title,
        }));
        setPriceTierList(priceTierRes || []);
      } catch (error) {
        console.error("Error fetching pricing tier:", error);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    setErrors({});
    setFormData((prevFormData) => ({
      ...prevFormData,
      price: undefined,
    }));
  }, [clearForm]);

  useEffect(() => {
    if (callFunction) {
      handleSubmit();
    }
  }, [callFunction]);

  useEffect(() => {
    setFormData((prevErrors: any) => ({
      ...prevErrors,
      price: price,
    }));
  }, [price]);

  useEffect(() => {
    if (localStorageCleared) {
      const savedFormData = loadFormDataFromLocalStorage();
      setFormData(savedFormData);
    }
  }, [localStorageCleared]);
  return (
    <div className=" track-overlay-wrapper container-fluid p-5 mx-auto">
      <div className="row">
        <div className="col-12 col-md-6">
          <div className="fields-wrapper flex-grow-shrink flex justify-content-between items-center tw-gap-[20px] tw-my-[20px]">
            <label>Choose a main price tier *</label>

            <Select
              className="select-search basic-single"
              classNamePrefix="select"
              placeholder="Please select Genre"
              isMulti={false}
              value={formData?.price || null}
              onChange={handleInputChange}
              options={priceTierList}
              isSearchable={true}
            />
            {errors.price && !formData.price && (
              <div className="text-danger">{errors.price}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Price;
